import axios, { AxiosResponse } from 'axios';
import { take, all, call, put, } from 'redux-saga/effects';
import { IRegisterEmailAct, SagaActTypes, IUseCouponAct } from './actions';
import { registerEmailStarted, registerEmailRejected, registerEmailFulfilled, issueCouponStarted, issueCouponRejected, issueCouponFulfilled, xuseCouponStarted, xuseCouponFulfilled, xuseCouponRejected, } from '../features/question/inputAnswerSlice';

import { RegisterEmailDto } from '../../../user-api/dist/src/dto/shopqr/register-email-dto';
import { CxHttpRes } from '../../../user-api/dist/src/dto/shopqr/shopqr-session-dto';
import i18next from 'i18next';

type PromiseType<T extends Promise<any>> = T extends Promise<infer P>
  ? P
  : never

async function putRegisterEmail(email: string): Promise<AxiosResponse<{
  status: string,
}>> {

  const data: RegisterEmailDto = {
    email,
    tzOffset: (new Date()).getTimezoneOffset()
  }

  const response = await axios.post<{ status: string }>(
    '/survey/api/shopqr/register_email',
    data,
  );

  return response;
}

async function putIssueCoupon(): Promise<AxiosResponse<CxHttpRes>> {

  const payload = {
    tzOffset: (new Date()).getTimezoneOffset()
  }
  const response = await axios.post<CxHttpRes>(
    '/survey/api/shopqr/issue_coupon',
    payload
  );

  return response;
}

async function putUseCoupon(couponToken: string): Promise<AxiosResponse<CxHttpRes>> {

  const data = {
    couponToken,
    tzOffset: (new Date()).getTimezoneOffset()
  };
  const response = await axios.post<CxHttpRes>(
    '/survey/api/shopqr/coupon/use/',
    data,
  );

  return response;
}

function* registerEmailSaga() {

  let registered = false;

  while (true) {

    const action: IRegisterEmailAct = yield take(SagaActTypes.RegisterEmail);

    if (!registered) {

      try {

        yield put(registerEmailStarted());
        const response: PromiseType<ReturnType<typeof putRegisterEmail>> = yield call(putRegisterEmail, action.payload.email);
        console.log(response);
        registered = true;
        yield put(registerEmailFulfilled());

      } catch (err) {

        yield put(registerEmailRejected());
        // そうそうエラーは起きないのでalertで対応する
        // 工数に余裕ができればModal表示する
        alert(i18next.t('common.error.our_server_is_very_busy_at_the_moment_please_come_back_after_a_while'));
        console.error(err);
      }
    }
  }
}

function* issueCoupon() {

  let issued = false;

  while (true) {

    yield take(SagaActTypes.IssueCoupon);

    if (!issued) {

      try {

        yield put(issueCouponStarted());
        const response: PromiseType<ReturnType<typeof putIssueCoupon>> = yield call(putIssueCoupon);
        // console.log(response);

        if (response.data.isError) {
          throw response.data.messages;
        }

        issued = true;

        yield put(issueCouponFulfilled({
          cxHttpRes: response.data,
        }));

      } catch (err) {

        yield put(issueCouponRejected());
        alert(i18next.t('common.error.our_server_is_very_busy_at_the_moment_please_come_back_after_a_while'));
        console.error(err);
      }
    }
  }
}

function* useCoupon() {

  let used = false;

  while (true) {

    const action: IUseCouponAct = yield take(SagaActTypes.UseCoupon);

    if (!used) {

      try {

        yield put(xuseCouponStarted());
        const response: PromiseType<ReturnType<typeof putUseCoupon>> = yield call(putUseCoupon, action.payload.couponToken);
        console.log(response);

        if (response.data.isError) {
          throw response.data.messages;
        }

        used = true;

        yield put(xuseCouponFulfilled({
          cxHttpRes: response.data,
        }));

      } catch (err) {

        yield put(xuseCouponRejected());
        alert(i18next.t('common.error.our_server_is_very_busy_at_the_moment_please_come_back_after_a_while'));
        console.error(err);
      }
    }
  }
}

export function* appRootSaga() {

  yield all([
    call(registerEmailSaga),
    call(issueCoupon),
    call(useCoupon),
  ])
}
